export type DictionaryCategoryId = string;

export interface IDictionaryCategory {
  id: DictionaryCategoryId;
  title: string;
  description: string;
}

export const dictionaryCategories: IDictionaryCategory[] = [
  {
    id: "dsp-connection-types",
    title: "DSP connection types",
    description: "Configure DSP integration types used by Agencies.",
  },
  {
    id: "account-managers",
    title: "Account managers (Sellers)",
    description: "List of account managers used in Sellers.",
  },
  {
    id: "agency-managers",
    title: "Account managers (Agencies)",
    description: "List of account managers used in Agencies.",
  },
  {
    id: "sales-representatives",
    title: "Sales representatives",
    description: "List of sales representatives used in Sellers.",
  },
  {
    id: "external-buyers",
    title: "External buyers",
    description: "List of external buyers.",
  },
  {
    id: "external-buyers-p2p",
    title: "External buyers (P2P)",
    description: "List of external buyers (P2P).",
  },
  {
    id: "presets",
    title: "Presets",
    description: "Configure Rill analytics field presets used by Sellers and Agencies.",
  },
];
